import React from "react"
import { View } from "react-native"
import TextM from "@common/components/text/TextM"

/** A small rounded label — the shape of the badges on a tutor's live cards. */
const PillBadgeM = ({ label, color, backgroundColor, style = {} }) => (
    <View
        style={{
            flexDirection: "row",
            alignItems: "center",
            borderRadius: 999,
            paddingHorizontal: 8,
            paddingVertical: 3,
            backgroundColor,
            ...style,
        }}
    >
        <TextM fontSize={10} fontWeight="Bold" color={color} style={{ flexShrink: 1 }}>
            {label}
        </TextM>
    </View>
)

export default PillBadgeM
